import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const documentacion = {
	state: {
		anexos: '',
		documentosEmpresa: '',
		documentosParaProyectoTalento:'',
		procesosParaProyectoTalento:''
	},
	getters: {
		getAnexos: state => state.anexos,
		getdocumentosEmpresa: state => state.documentosEmpresa,
		getdocumentosParaProyectoTalento: state => state.documentosParaProyectoTalento,
		getprocesosParaProyectoTalento: state => state.procesosParaProyectoTalento,
	},
	
	actions: {
		requestAnexos: function ({ commit, dispatch }, type) {

			let url = '/api/Empresa/dameAnexosPracticas';

			return new Promise((resolve, reject) => {
				axios.get(url).then(response => {
					(response.data.status == 0) ? commit('setAnexos', response.data.datos) : commit('setCompleteError', response);
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});

		},
		requestNotasinformativas: function ({ commit, dispatch }, type) {

			let url = '/api/Empresa/dameNotasInformativasPracticasCurricularExtraordinaria';

			return new Promise((resolve, reject) => {
				axios.get(url).then(response => {
					(response.data.status == 0) ? resolve(response.data.datos) : commit('setCompleteError', response);
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});

		},
		requestDocumentosEmpresa({ commit, dispatch }) {
			return new Promise((resolve, reject) => {
				axios.get('/api/empresa/documentosAportados').then(response => {
					(response.data.status == 0) ? commit('setDocumentosEmpresa', response.data.datos) : commit('setCompleteError', response);
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestProcesosParaProyectoTalento({ commit, dispatch }) {
			return new Promise((resolve, reject) => {
				axios.get('/api/empresa/documentosAportadosProyectoTalento').then(response => {
					(response.data.status == 0) ? commit('setDocumentosParaProyectoTalento', response.data.datos) : commit('setCompleteError', response);
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestOfertasAsociadasParaProyectoTalento({ commit, dispatch }) {
			return new Promise((resolve, reject) => {
				axios.get('/api/empresa/dameProcesosParaProyectoTalento').then(response => {
					(response.data.status == 0) ? commit('setProcesosParaProyectoTalento', response.data.datos) : commit('setCompleteError', response);
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestDocumentosProgramas({ commit, dispatch }) {
			return new Promise((resolve, reject) => {
				axios.get('/api/empresa/dameDocumentosPracticasPorPrograma').then(response => {
					(response.data.status == 0) ? resolve(response.data.datos) : commit('setCompleteError', response);
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		saveDoc({ commit, dispatch }, doc) {
			return new Promise((resolve, reject) => {
				axios.post('/api/empresa/adddoc', doc).then(response => {

					if (response.data.status == 0) {
						dispatch('requestDocumentosEmpresa');
						resolve(true);
					} else {
						commit('setCompleteError', response);
						reject(false);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		eraseDocEmpresa({ commit, dispatch }, id) {
			return new Promise((resolve, reject) => {
				let data = { "id": id };
				axios.post('/api/empresa/deldoc', data).then(response => {
					if (response.data.status == 0) {
						dispatch('requestDocumentosEmpresa');
						resolve(true);
					} else {
						commit('setCompleteError', response);
						resolve(false);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		}
	},
	mutations: {
		setAnexos: function (state, data) {
			state.anexos = data;
		},
		setDocumentosEmpresa(state, data) {
			state.documentosEmpresa = data;
		},
		setDocumentosParaProyectoTalento(state, data) {
			state.documentosParaProyectoTalento = data;
		},
		setProcesosParaProyectoTalento(state, data) {
			state.procesosParaProyectoTalento = data;
		}
	}
}

export default documentacion;



// WEBPACK FOOTER //
// ./src/store/documentacion.js